import React from 'react';
import MomentUtils from '@date-io/moment';

import {
  MuiPickersUtilsProvider,
  DatePicker as MuiDatePicker,
} from '@material-ui/pickers';

import CalendarIcon from '../../../assets/icons/CalendarIcon';

import './new-date-picker.scss';

const DatePicker = (props) => {
  const {
    date,
    onDateChange,
    disableFuture = false,
    disablePast = false,
    placeholder = 'Add Date',
    disabled = false,
    minDate = new Date('1990-01-01'),
    maxDate = new Date('2100-01-01'),
    withoutStyles = false,
    format = 'DD/MM/yyyy',
  } = props;

  return (
    <div className={`new-date-picker__container${withoutStyles ? ' new-date-picker__without-styles' : ''}`}>
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <MuiDatePicker
          clearable
          value={date || null}
          placeholder={placeholder || 'Add date'}
          onChange={onDateChange}
          minDate={minDate}
          maxDate={maxDate}
          minDateMessage={null}
          format={format}
          disableFuture={disableFuture}
          disablePast={disablePast}
          emptyLabel={placeholder}
          disabled={disabled}
        />
      </MuiPickersUtilsProvider>
      {!disabled && (
        <>
          <CalendarIcon />
        </>
      )}
    </div>
  );
};

export default DatePicker;
